export const removeDuplicate = <T>(arr: T[]): T[] => arr.filter((item, i) => arr.indexOf(item) === i)

export const removeDuplicateGeneric = <T>(arr: T[]): T[] =>
  arr.filter((value, index, self) => index === self.findIndex((t) => JSON.stringify(t) === JSON.stringify(value)))

export const convertToLowerCase = (arr: string[]): string[] => arr.map((value) => value.toLocaleLowerCase())
